import Vue from 'vue';

const state = {
    userExists: false,
    userLoggedIn: false,
    email: null,
    user: {}
}

const actions = {
    saveUserExists({ commit }, payload) {
        commit('SAVE_USER_EXISTS', payload);
    },
    
    toggleUserLoggedIn({ commit }, payload) {
        commit('SAVE_USER_LOGGED_IN', payload);
        commit('SAVE_USER_EXISTS', payload);
    },
    
    saveUserEmail({ commit }, email) {
        commit('SAVE_USER_EMAIL', email);
    },
    
    saveUserData({ commit }, userData) {
        commit('SAVE_USER', userData);
    },
    
    saveAddress({ commit }, payload) {
        commit('SAVE_ADDRESS', payload);
    },
    
    removeAddress({ commit }, id) {
        commit('REMOVE_ADDRESS', id);
    },
    
    savePrimaryAddress({ commit }, payload) {
        commit('SAVE_PRIMARY_ADDRESS', payload);
    }
}

const mutations = {
    SAVE_USER_EXISTS(state, payload) {
        state.userExists = payload;
    },
    
    SAVE_USER_LOGGED_IN(state, payload) {
        state.userLoggedIn = payload;
    },
    
    SAVE_USER_EMAIL(state, email) {
        state.email = email;
    },
    
    SAVE_USER(state, userData) {
        state.user = userData;
    },
    
    SAVE_ADDRESS(state, { id, addressData }) {
        let existingAddressIndex = state.user.addresses.addresses.findIndex(address => address.id === id);
        Vue.set(state.user.addresses.addresses, existingAddressIndex, addressData);
    },
    
    REMOVE_ADDRESS(state, id) {
        let existingAddressIndex = state.user.addresses.addresses.findIndex(address => address.id === id);
        state.user.addresses.addresses.splice(existingAddressIndex, 1);
    },
    
    SAVE_PRIMARY_ADDRESS(state, payload) {
        if (payload.shipping) {
            state.user.addresses['primaryShippingAddressId'] = payload.id;
        }
        if (payload.billing) {
            state.user.addresses['primaryBillingAddressId'] = payload.id;
        }
    }
}

const getters = {
    getAddressById: state => id => {
        if (state.user?.addresses?.addresses.length) {
            return state.user.addresses.addresses.find(address => address.id === id);
        }
        return null;
    },
    
    getAddresses(state) {
        if (state.user?.addresses?.addresses) {
            return state.user.addresses.addresses;
        }
        return [];
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
